import ReactGA from "react-ga4";
import K from "../../utilities/constants";

const { GoogleAnalytics } = K;

export const initGA = () => {
  ReactGA.initialize(process.env.REACT_APP_MEASUREMENT_ID, {
    // gaOptions: {
    //   userId: User.getUserId(),
    //   clientId: User.getUserId(),
    // },
  });
};
//
export const GAPageView = (page) => {
  ReactGA.send({ hitType: "pageview", page });
};

export const GASendEvent = (options) => {
  ReactGA.event(options);

  /* {
    category: "Download",
    action: "Export",
    label: "your label", // optional
     value: 99, // optional, must be a number
     nonInteraction: true, // optional, true/false
     transport: "xhr", // optional, beacon/xhr/image
  } */
};

export const injectGA = () => {
  if (typeof window == "undefined") {
    return;
  }
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  gtag("js", new Date());

  gtag("config", process.env.REACT_APP_MEASUREMENT_ID);
};
